import { render, staticRenderFns } from "./HistoryChart.vue?vue&type=template&id=4a84acbc"
import script from "./HistoryChart.vue?vue&type=script&lang=js"
export * from "./HistoryChart.vue?vue&type=script&lang=js"
import style0 from "./HistoryChart.vue?vue&type=style&index=0&id=4a84acbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports